// test1241
(1241 && 0);
